import MangaCard from '@/components/feature/MangaCard';
import { hotRecommend } from '@/mocks/manga';

export default function HotRecommend() {
  return (
    <section id="hot-recommend" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">评分最高的精选漫画，不容错过</p>
          </div>
          <a
            href="/category/rexue"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看更多
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotRecommend.map((manga) => (
            <MangaCard key={manga.id} {...manga} />
          ))}
        </div>
      </div>
    </section>
  );
}